export default "__VITE_ASSET__Dr4EscBj__"